<template>
  <div>
    <PageAllow
      controller="Suppliers"
      :action="(settings && settings.supplier_self_purchase) ? 'index' : 'selfPurchaseSave'"
    />
    <Breadcrumbs :items="items" />

    <v-sheet class="transparent-background-color">
      <v-row dense class="mx-5">
        <v-col cols="12" sm="6" md="4">
          <v-row dense align="center" class="pa-1">
            <SearcherKeyword
              ref="keyword"
              v-model="options.keyword"
              @text="keyword = $event"
              :label="$t('SupplierSelfPurchase.keyword')"
            />
          </v-row>
        </v-col>
        <!-- 按钮 -->
        <v-col cols="12" sm="12" md="8" align-self="center">
          <v-row dense align="center">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  text
                  class="px-0 py-0 caption font-weight-bold grey--text"
                  color="primary"
                  @click.stop="onSearch()"
                >
                  <v-icon small class="pe-1">fa-search</v-icon>
                  {{ $t("Search.search") }}
                </v-btn>
              </template>
              <span>{{ $t("Search.searchTip") }}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  text
                  class="caption font-weight-bold grey--text"
                  @click.stop="resetSearch()"
                >
                  <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                  {{ $t("Search.reset") }}
                </v-btn>
              </template>
              <span>{{ $t("Search.resetTip") }}</span>
            </v-tooltip>
            <v-spacer />
            <v-btn
              small
              color="primary"
              @click="saveSuppliers()"
              class="ms-1"
            >
              <v-icon x-small class="pe-1">fa-save</v-icon>
              {{ $t("CRUD.save") }}
            </v-btn>
          </v-row>
        </v-col>
        <v-col cols="12" sm="1" md="1">
          <v-row dense align="center" class="pa-1">
            <SearcherStatus
              v-model="selfPurchase"
              :items="[
                {
                  text: $t('SupplierSelfPurchase.self_purchase'),
                  color: 'primary',
                  textColor: 'white',
                  value: 1,
                },
              ]"
            />

          </v-row>
        </v-col>
        <v-col cols="12" sm="1" md="1" class="ml-5">
          <v-row dense align="center" class="pa-1">
            <SearcherStatus
              v-model="selfPurchaseAutoConfirm"
              :items="[
                {
                  text: $t('SupplierSelfPurchase.self_purchase_auto_confirm'),
                  color: 'primary',
                  textColor: 'white',
                  value: 1,
                },
              ]"
            />
          </v-row>
        </v-col>
      </v-row>

      <div class="mx-4 mb-4">
        <v-data-table
          :headers="headers"
          :items="suppliers"
          :options.sync="options"
          :page.sync="paging.page"
          :server-items-length="paging.count"
          :loading="loading"
          multi-sort
          class="elevation-1 px-4 pt-1 sticky-table"
          id="sticky-table"
          :class="stickTableCols ? 'sticky-first-col sticky-last-col' : ''"
          fixed-header
          :footer-props="footerProps"
        >    : 0,
          : 0,
          <template v-slot:body.prepend>
            <tr class="d-none d-sm-table-row">
              <td></td>
              <td></td>
              <td class="align-center">
                <v-checkbox
                  class="mt-2 mb-n2"
                  color="primary"
                  :indeterminate="
                    suppliers.find(
                      (detail) => detail.self_purchase != selfPurchaseAll
                    )
                      ? false
                      : true
                  "
                  v-model="selfPurchaseAll"
                  :true-value="true"
                  :false-value="false"
                >
                  <template v-slot:label>
                    <span class="caption ms-n2">
                      {{ $t("MaterialTemplate.thisPage")}}{{ $t("SupplierSelfPurchase.checkBoxAll") }}
                    </span>
                  </template>
                </v-checkbox>
              </td>
              <td class="align-center">
                <v-checkbox
                  class="mt-2 mb-n2"
                  color="primary"
                  :indeterminate="
                    suppliers.find(
                      (detail) => detail.self_purchase_auto_confirm != selfPurchaseAutoConfirmAll
                    )
                      ? false
                      : true
                  "
                  v-model="selfPurchaseAutoConfirmAll"
                  :true-value="true"
                  :false-value="false"
                >
                  <template v-slot:label>
                    <span class="caption ms-n2">
                      {{ $t("MaterialTemplate.thisPage")}}{{ $t("SupplierSelfPurchase.checkBoxAll") }}
                    </span>
                  </template>
                </v-checkbox>
              </td>
              <td></td>
              <td></td>
            </tr>
          </template>
          <template v-slot:item.self_purchase="{ item }">
            <div class="d-flex mt-n2 mb-n3">
              <v-checkbox
                color="primary"
                v-model="item.self_purchase"
                :true-value="1"
                :false-value="0"
              >
                <template v-slot:label>
                  <span class="caption ms-n2">
                    {{
                      $t(
                        item.self_purchase
                            ? "SupplierSelfPurchase.Fields.check_box_on"
                            : "SupplierSelfPurchase.Fields.check_box_off"
                      )
                    }}
                  </span>
                </template>
              </v-checkbox>
            </div>
          </template>
          <template v-slot:item.self_purchase_auto_confirm="{ item }">
            <div class="d-flex mt-n2 mb-n3">
              <v-checkbox
                color="primary"
                v-model="item.self_purchase_auto_confirm"
                :true-value="1"
                :false-value="0"
              >
                <template v-slot:label>
                  <span class="caption ms-n2">
                    {{
                      $t(
                        item.self_purchase_auto_confirm
                          ? "SupplierSelfPurchase.Fields.check_box_on"
                          : "SupplierSelfPurchase.Fields.check_box_off"
                      )
                    }}
                  </span>
                </template>
              </v-checkbox>
            </div>
          </template>
          <template v-slot:item.stock="{ item }">
            <v-btn
              class="primary"
              small
              @click="
                supplierStocksDialog = true;
                currentItem = item;
              "
            >
              {{
                $t("CRUD.chooseInfo", [
                  $t("Stock.ObjectName"),
                ])
              }}
            </v-btn>
          </template>
          <template v-slot:item.stockSelected="{ item }">
            <span
              v-for="(stock, index) in item.stocks"
                :key="index"
            >
              {{ stock.name }}
              <span v-if="index < item.stocks.length - 1">
                {{ $t("Global.pause") }}
              </span>
            </span>
          </template>
        </v-data-table>
      </div>
    </v-sheet>
    <DialogStocks
      v-model="supplierStocksDialog"
      :stockSelected="
        currentItem && currentItem.stocks ? currentItem.stocks : []
      "
      @confirm="
        currentItem.stocks = $event;
        supplierStocksDialog = false;
      "
      :types="[0]"
      :status="[1]"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
import SearcherStatus from "@/components/plugins/SearcherStatus";
import DialogStocks from "@/components/plugins/DialogStocks.vue";
import Suppliers from "@/api/suppliers";

const defaultOptions = {
  keyword: "",
  self_purchase: [],
  self_purchase_auto_confirm: [],
  type: 1,
  stop_flg: [0],
  order_to_purchase: 2,
  self_purchase_flg: 1,
};

export default {
  components: {
    DialogStocks,
    PageAllow,
    Breadcrumbs,
    SearcherKeyword,
    SearcherStatus,
  },

  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.purchases"),
        disabled: false,
        href: "/supplier",
      },
      {
        text: i18n.t("Nav.supplierSelfPurchase"),
        disabled: true,
        href: "/supplier",
      },
    ],
    headers() {
      return [
        {
          text: i18n.t("SupplierSelfPurchase.Fields.supplier_code"),
          align: "start",
          sortable: false,
          value: "supplier_code",
          // width: "200",
        },
        {
          text: i18n.t("SupplierSelfPurchase.Fields.supplier_name"),
          align: "start",
          sortable: false,
          value: "supplier_name",
          // width: "500",
        },
        {
          text: i18n.t("SupplierSelfPurchase.Fields.self_purchase"),
          align: "start",
          sortable: false,
          filterable: false,
          value: "self_purchase",
          // width: "200",
        },
        {
          text: i18n.t("SupplierSelfPurchase.Fields.self_purchase_auto_confirm"),
          align: "start",
          sortable: false,
          filterable: false,
          value: "self_purchase_auto_confirm",
          // width: "200",
        },
        {
          text: i18n.t("SupplierSelfPurchase.Fields.stock"),
          align: "start",
          sortable: false,
          value: "stock",
          // width: "200",
        },
        {
          text: i18n.t("SupplierSelfPurchase.Fields.stockSelected"),
          align: "start",
          sortable: false,
          value: "stockSelected",
          width: "300",
        },
      ];
    },
    footerProps() {
      let props = i18n.t("$config.footer-props");
      props.itemsPerPageOptions.push(-1);
      return props;
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings", "stickTableCols", "accountInfo"]),
  },

  mounted() {

  },

  data: () => ({
    mode: "",
    keyword: "",
    selfPurchase: [],
    selfPurchaseAutoConfirm: [],
    options: JSON.parse(JSON.stringify(defaultOptions)),
    paging: {},
    suppliers: [],
    selfPurchaseAll: false,
    selfPurchaseAutoConfirmAll: false,
    supplierStocksDialog: false,
    currentItem: {},
  }),

  methods: {
    onSearch() {
      this.options = Object.assign({}, this.options, {
        keyword: this.keyword,
      });
    },
    resetSearch() {
      this.selfPurchase = [];
      this.selfPurchaseAutoConfirm = [];
      this.options = JSON.parse(JSON.stringify(defaultOptions))
    },
    getSuppliersFromAPI() {
      this.$store.dispatch("fullscreenLoading");
      Suppliers.fetch(this.options)
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.suppliers = response.data.suppliers;
              this.selfPurchaseAll = true;
              this.selfPurchaseAutoConfirmAll = true;
              this.suppliers.map(function (supplier) {
                if (!supplier.self_purchase) {
                  this.selfPurchaseAll = false;
                }
                if (!supplier.self_purchase_auto_confirm) {
                  this.selfPurchaseAutoConfirmAll = false;
                }
              }.bind(this))
              this.paging = response.data.paging;
            } else if (response.data.error.code.isNoResultSet()) {
              this.options.page = 1;
            }
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        )
        .catch(
          function () {
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        );
    },
    saveSuppliers() {
      this.$store.dispatch("fullscreenLoading");
      let data = this.suppliers.map(function (detail) {
        let detailData =   {
          supplier_id: detail.id,
          self_purchase: detail.self_purchase,
          self_purchase_auto_confirm: detail.self_purchase_auto_confirm,
          self_purchase_stocks: (detail.stocks && detail.stocks.length) > 0 ? detail.stocks.map((stock) => {return stock.id}) : []
        }
        return detailData;
      }.bind(this))
      console.log('data', data)

      Suppliers.selfPurchaseSave(data).then(
          function (response) {
            if (response.data.status.isOK()) {
              this.options.page = 1;
              this.getSuppliersFromAPI()
            }
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
      ).catch(function () {
        this.$store.dispatch("fullscreenLoadingStop");
      })
    },

  },

  watch: {
    selfPurchaseAll: {
      handler() {
        this.suppliers = this.suppliers.map(
            function (detail) {
              detail.self_purchase = this.selfPurchaseAll ? 1 : 0;
              return detail;
            }.bind(this)
        );
      },
    },
    selfPurchaseAutoConfirmAll: {
      handler() {
        this.suppliers = this.suppliers.map(
            function (detail) {
              detail.self_purchase_auto_confirm = this.selfPurchaseAutoConfirmAll ? 1 : 0;
              return detail;
            }.bind(this)
        );
      },
    },
    options: {
      deep: true,
      handler() {
        this.getSuppliersFromAPI();
      },
    },
  },
};
</script>